import { TopNav } from "@/components/layout/TopNav";
import { Footer } from "@/components/layout/Footer";
import { AnimatedBackground } from "@/components/AnimatedBackground";

export function PublicLayout({ children }) {
  return (
    <div className="relative min-h-screen text-white">
      <AnimatedBackground />
      <TopNav />
      <main className="pt-16">{children}</main>
      <Footer />
    </div>
  );
}
